import React from 'react';
import { Switch, Route } from 'react-router-dom';
import useRoutes from 'src/routes/useRoutes';
import { settings } from 'src/routes/routes';
import JOB_TYPES from './Jobs/models/jobTypesModel';
import LimitedWidthPage from '../../components/PageWrappers/LimitedWidthPage';
import DashBoardMenu from '../../components/app/DashBoardMenu';
const AbsencesImportSettings = React.lazy(() => import('./AbsencesImportSettings'));
const ApiClients = React.lazy(() => import('./ApiClients'));
const Comments = React.lazy(() => import('./Comments'));
const CompensationProducts = React.lazy(() => import('./CompensationProducts'));
const ConfigurationContainer = React.lazy(() => import('./Configuration'));
const DepartmentsContainer = React.lazy(() => import('./Departments'));
const DepartmentsTasksContainer = React.lazy(() => import('./DepartmentsTasks'));
const ImportFormArgos = React.lazy(() => import('./ImportFormArgos'));
const JobProfilesContainer = React.lazy(() => import('./JobProfiles'));
const JobsContainer = React.lazy(() => import('./Jobs'));
const JobsRelations = React.lazy(() => import('./JobsRelations'));
const JobsTableContainer = React.lazy(() => import('./JobsTable'));
const LawContainer = React.lazy(() => import('./Law'));
const ModulesContainer = React.lazy(() => import('./Modules'));
const PlannerPolicy = React.lazy(() => import('./PlannerPolicy'));
const PlannerRequestsTypes = React.lazy(() => import('./PlannerRequestsTypes'));
const Professions = React.lazy(() => import('./Professions'));
const RenewStandardTimesContainer = React.lazy(() => import('./RenewStandardTimes'));
const RewardTypes = React.lazy(() => import('./RewardTypes'));
const SimpleRegistrars = React.lazy(() => import('./SimpleRegistrars'));
const Skills = React.lazy(() => import('./Skills'));
const SlipTimesContainer = React.lazy(() => import('./SlipTimes'));
const StatementTypes = React.lazy(() => import('./StatementTypes'));
const TvManagementContainer = React.lazy(() => import('./TvManagement'));
const UserRightContainer = React.lazy(() => import('./UserRight'));
const WccManagementContainer = React.lazy(() => import('./WccManagement'));
const WccMotContainer = React.lazy(() => import('./WccMot'));
const WorkDayEventContainer = React.lazy(() => import('./WorkDayEvents'));
const WorkShifts = React.lazy(() => import('./WorkShifts'));
const WorkSites = React.lazy(() => import('./WorkSites'));
const WorkTimeTypes = React.lazy(() => import('./WorkTimeTypes'));
function SettingsMenu() {
    const { getAllowedRoutes } = useRoutes();
    const renderMenu = () => (React.createElement(LimitedWidthPage, null,
        React.createElement(DashBoardMenu, { routes: getAllowedRoutes(settings.subPages), sortAlphabetically: true })));
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "/settings/apiClients", component: ApiClients }),
        React.createElement(Route, { path: "/settings/law", component: LawContainer }),
        React.createElement(Route, { path: "/settings/jobsRelations", component: JobsRelations }),
        React.createElement(Route, { path: "/settings/professions", component: Professions }),
        React.createElement(Route, { path: "/settings/skills", component: Skills }),
        React.createElement(Route, { path: "/settings/statementTypes", component: StatementTypes }),
        React.createElement(Route, { path: "/settings/absencesImport", component: AbsencesImportSettings }),
        React.createElement(Route, { path: "/settings/workSites", component: WorkSites }),
        React.createElement(Route, { path: "/settings/wccMot", component: WccMotContainer }),
        React.createElement(Route, { path: "/settings/modules", component: ModulesContainer }),
        React.createElement(Route, { path: "/settings/workTimeTypes", component: WorkTimeTypes }),
        React.createElement(Route, { path: "/settings/jobsTable", component: JobsTableContainer }),
        React.createElement(Route, { path: "/settings/userRight", component: UserRightContainer }),
        React.createElement(Route, { path: "/settings/slipTimes", component: SlipTimesContainer }),
        React.createElement(Route, { path: "/settings/importFromArgos", component: ImportFormArgos }),
        React.createElement(Route, { path: "/settings/jobProfiles", component: JobProfilesContainer }),
        React.createElement(Route, { path: "/settings/departments", component: DepartmentsContainer }),
        React.createElement(Route, { path: "/settings/tvManagement", component: TvManagementContainer }),
        React.createElement(Route, { path: "/settings/workDayEvents", component: WorkDayEventContainer }),
        React.createElement(Route, { path: "/settings/configuration", component: ConfigurationContainer }),
        React.createElement(Route, { path: "/settings/wccManagement", component: WccManagementContainer }),
        React.createElement(Route, { path: "/settings/departmentsTasks", component: DepartmentsTasksContainer }),
        React.createElement(Route, { path: "/settings/RenewStandardTimes", component: RenewStandardTimesContainer }),
        React.createElement(Route, { path: "/settings/plannerPolicy", component: PlannerPolicy }),
        React.createElement(Route, { path: "/settings/requestTypes", component: PlannerRequestsTypes }),
        React.createElement(Route, { path: "/settings/shifts", component: WorkShifts }),
        React.createElement(Route, { path: "/settings/comments", component: Comments }),
        React.createElement(Route, { path: "/settings/compensationProducts", component: CompensationProducts }),
        React.createElement(Route, { path: "/settings/rewardTypes", component: RewardTypes }),
        React.createElement(Route, { path: "/settings/SimpleRegistrars", component: SimpleRegistrars }),
        React.createElement(Route, { path: "/settings/jobs" }, (props) => React.createElement(JobsContainer, { jobType: JOB_TYPES.ACTIONS, ...props })),
        React.createElement(Route, { path: "/settings/jobAbsences" }, (props) => React.createElement(JobsContainer, { jobType: JOB_TYPES.ABSENCES, ...props })),
        React.createElement(Route, { path: "/settings", component: renderMenu })));
}
export default SettingsMenu;
